import { render, staticRenderFns } from "./MailTemplates.vue?vue&type=template&id=394a576a&scoped=true"
import script from "./MailTemplates.vue?vue&type=script&lang=js"
export * from "./MailTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394a576a",
  null
  
)

export default component.exports